import React from "react";
import { Tag } from "@design-system/Tag/Tag";
import styles from "./ActiveFilterButton.module.scss";

interface ActiveFilterButtonProps {
    resetFilter: () => void;
    openFilter?: () => void;
    label: React.ReactNode;
    disabled?: boolean;
}

export const ActiveFilterButton: React.FC<ActiveFilterButtonProps> = ({
    openFilter,
    resetFilter,
    label,
    disabled = false,
}) => {
    if (disabled) {
        return (
            <Tag
                size="lg"
                color="accent"
                className={styles.tag}
                data-testid="active-filter-button"
            >
                {label}
            </Tag>
        );
    }

    return (
        <Tag
            size="lg"
            color="accent"
            className={styles.tag}
            data-testid="active-filter-button"
            onClick={openFilter}
            onRemove={resetFilter}
            removeLabel="Remove filter"
        >
            {label}
        </Tag>
    );
};
